<template>
  <iframe
    id="levelMap"
    title="GIS MAP"
    width="100%"
    height="88%"
    :src="`./static/gis/level_map.html`"
    @load="load"
  />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DxExploitation',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('authentication', ['languageSelected']),
  },
  watch: {
    languageSelected() {
      this.translator();
    },
  },
  methods: {
    load() {
      this.translator();
      window.document.addEventListener('updateTranslator', this.translator, false);
    },
    translator() {
      const iframe = document.getElementById('levelMap');

      iframe.contentWindow.document.getElementById('defineFarmNameAndIrrigableArea').innerHTML = this.$t('defineFarmNameAndIrrigableArea');
      iframe.contentWindow.document.getElementById('selectCountry').innerHTML = this.$t('selectCountry');
      iframe.contentWindow.document.getElementById('spain').innerHTML = this.$t('spain');
      iframe.contentWindow.document.getElementById('lebanon').innerHTML = this.$t('lebanon');
      iframe.contentWindow.document.getElementById('tunisia').innerHTML = this.$t('tunisia');
      iframe.contentWindow.document.getElementById('name').innerHTML = this.$t('name');

      const location = iframe.contentWindow.document.getElementById('location');
      if (location) {
        location.innerHTML = this.$t('location');
      }
      const nameStation = iframe.contentWindow.document.getElementById('nameStation');
      if (nameStation) {
        nameStation.innerHTML = this.$t('nameStation');
      }
      const idStation = iframe.contentWindow.document.getElementById('idStation');
      if (idStation) {
        idStation.innerHTML = this.$t('idStation');
      }
      const provider = iframe.contentWindow.document.getElementById('provider');
      if (provider) {
        provider.innerHTML = this.$t('provider');
      }
      const irrigableArea = iframe.contentWindow.document.getElementById('irrigableArea');
      if (irrigableArea) {
        irrigableArea.innerHTML = this.$t('irrigableArea');
      }
      const id = iframe.contentWindow.document.getElementById('id');
      if (id) {
        id.innerHTML = this.$t('id');
      }
      const selectStation = iframe.contentWindow.document.getElementById('selectStation');
      if (selectStation) {
        selectStation.innerHTML = this.$t('selectStation');
      }
      const agroclimaticStation = iframe.contentWindow.document.getElementById('agroclimaticStation');
      if (agroclimaticStation) {
        agroclimaticStation.innerHTML = this.$t('agroclimaticStation');
      }
      const noStations = iframe.contentWindow.document.getElementById('noStations');
      if (noStations) {
        noStations.innerHTML = this.$t('noStations');
      }
      const region = iframe.contentWindow.document.getElementById('region');
      if (region) {
        region.innerHTML = this.$t('region');
      }
      const save = iframe.contentWindow.document.getElementById('w-change-save');
      if (save) {
        save.innerHTML = this.$t('Save');
      }
      const close = iframe.contentWindow.document.getElementById('w-change-close-edit');
      if (close) {
        close.innerHTML = this.$t('close');
      }
      const editName = iframe.contentWindow.document.getElementById('editName');
      if (editName) {
        editName.innerHTML = this.$t('name');
      }
      const editIrrigableArea = iframe.contentWindow.document.getElementById('editIrrigableArea');
      if (editIrrigableArea) {
        editIrrigableArea.innerHTML = this.$t('irrigableArea');
      }
      const editDesiredData = iframe.contentWindow.document.getElementById('editDesiredData');
      if (editDesiredData) {
        editDesiredData.innerHTML = this.$t('editDesiredData');
      }
      const cancel = iframe.contentWindow.document.getElementById('w-change-close');
      if (cancel) {
        cancel.innerHTML = this.$t('cancel');
      }
      const accept = iframe.contentWindow.document.getElementById('w-change-btn');
      if (accept) {
        accept.innerHTML = this.$t('accept');
      }
      const irrigableAreaLabel = iframe.contentWindow.document.getElementById('irrigableAreaLabel');
      if (irrigableAreaLabel) {
        irrigableAreaLabel.innerHTML = this.$t('irrigableArea');
      }
      const nameLabel = iframe.contentWindow.document.getElementById('nameLabel');
      if (nameLabel) {
        nameLabel.innerHTML = this.$t('name');
      }
    },
  },
};
</script>

<style scoped>
</style>
